var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { icon: "", disabled: _vm.notifications.length < 1 },
                    on: {
                      click: function($event) {
                        return _vm.showNotifications()
                      }
                    }
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [
                  _c(
                    "v-badge",
                    _vm._g(
                      {
                        attrs: {
                          color: "red",
                          content: _vm.notifications.length,
                          value: _vm.notifications.length,
                          overlap: "",
                          small: !(_vm.notifications.length > 0)
                        }
                      },
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        {
                          style: {
                            padding:
                              _vm.notifications.length > 0 ? "18px" : "0px",
                            "border-radius": "50%",
                            "background-color":
                              _vm.notifications.length > 0 ? "black" : "white",
                            color:
                              _vm.notifications.length > 0 ? "white" : "black"
                          }
                        },
                        [_vm._v("mdi-bell")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { light: "", color: "white" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "black" } }, [
                    _vm._v("mdi-arrow-left")
                  ])
                ],
                1
              ),
              _c("v-toolbar-title", { staticStyle: { color: "#000000" } }, [
                _vm._v("Notifications")
              ]),
              _c("v-spacer"),
              _c("v-toolbar-items")
            ],
            1
          ),
          _c(
            "v-list",
            { attrs: { "three-line": "" } },
            [
              _vm._l(_vm.notifications, function(item, index) {
                return [
                  _c("v-divider", { key: "Divider::" + index }),
                  _c(
                    "v-list-item",
                    {
                      key: "notification" + index,
                      class: { viewed: item.viewed },
                      attrs: { dark: item.viewed == true, dense: "" },
                      on: {
                        click: function($event) {
                          return _vm.doAction(item)
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        { staticStyle: { width: "20px" } },
                        [
                          _c("v-img", {
                            attrs: { src: require("img/icons/wifirequest.svg") }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        { staticStyle: { "padding-top": "0px" } },
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticStyle: {
                                color: "#f4693a",
                                "font-size": "16px"
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _c(
                            "v-list-item-subtitle",
                            {
                              staticStyle: {
                                color: "#000000",
                                "font-size": "14px",
                                "margin-top": "-20px"
                              }
                            },
                            [_vm._v(_vm._s(item.body))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        {
                          staticStyle: {
                            "align-self": "center",
                            "margin-top": "5px"
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            { attrs: { icon: "" } },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey darken-3" } },
                                [_vm._v("mdi-chevron-right")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }